import { render, staticRenderFns } from "./AffiliateLinksDisplay.vue?vue&type=template&id=53613afc&"
import script from "./AffiliateLinksDisplay.vue?vue&type=script&lang=js&"
export * from "./AffiliateLinksDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateLinksDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports